<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <el-form
        class="details-line-height"
        style="padding:20px 30px 0 30px"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票编号：">{{params.invoiceReceiveNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票类型：">{{params.invoiceType}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收票类型：">{{params.bilingType}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="公司名称：">{{params.invoiceReceiveCompany}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票编号：">{{params.invoiceNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{params.createDate | dateFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>票据信息</span>
      </div>
      <el-form
        class="details-line-height"
        style="padding:20px 30px 0 30px"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票状态：">{{status[params.invoiceState-1]||'--'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票金额：">{{params.amount | toFixed}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票税额：">{{params.allTaxAmount}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="处理人：">{{params.createUser}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收票时间：">{{params.invoiceReceiveDate | dateFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="item-box-content"
      v-if="$route.query.type ==='merge'||params.purchaseContractInvocieNoticketVoList!==null"
    >
      <div class="title-font-style">
        <span>合同列表</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        max-height="378"
        :data="params.purchaseContractInvocieNoticketVoList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="contractFrom"
          label="合同类型"
          width="110"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="pcbNumber"
          label="合同编号"
          width="120"
        >
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="pcbNumberClick(scope.row)"
            >{{ scope.row.pcbNumber}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="supplierContractNumber"
          width="150px"
          label="供应商编号"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="suName"
          width="150px"
          label="供应商名称"
        >
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="suNameClick(scope.row)"
            >{{ scope.row.suName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="payType"
          label="付款类型"
        ></el-table-column>
        <el-table-column
          prop="noInvoice"
          label="未收票金额"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="contractMoney"
          label="合同总额"
        ></el-table-column>
        <el-table-column
          prop="contractState"
          label="合同状态"
        ></el-table-column>
        <el-table-column
          prop="deliverState"
          label="发货状态"
        ></el-table-column>
        <el-table-column
          prop="actualTotal"
          label="已付账款"
        >
          <template v-slot="{row}">{{row.actualTotal|toFixed}}</template>
        </el-table-column>
        <el-table-column
          prop="dueMoney"
          label="已到期账款"
          width="100px"
        >
          <template v-slot="{row}">{{row.dueMoney|toFixed}}</template>
        </el-table-column>
        <el-table-column
          prop="invoiceState"
          label="收票状态"
        ></el-table-column>
        <el-table-column
          prop="staffUsename"
          label="当前负责人"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="orgName"
          label="所属部门"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          show-overflow-tooltip
          width="150px"
          label="签订时间"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.createDate | dateFilter }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>产品详情</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        max-height="378"
        :data="params.purchaseContractInvociesVoList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="pcbNumber"
          show-overflow-tooltip
          label="采购合同编号"
          width="110px"
        >
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="pcbNumberClick(scope.row)"
            >{{ scope.row.pcbNumber}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="supplierContractNumber"
          show-overflow-tooltip
          label="供应商合同编号"
          width="150px"
        ></el-table-column>
        <el-table-column
          prop="proName"
          label="产品名称"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="line-limit-length">{{ scope.row.proName}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="proModel"
          show-overflow-tooltip
          label="型号"
        >
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="proNameClick(scope.row)"
            >{{ scope.row.proModel}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="proOrdernum"
          show-overflow-tooltip
          label="订货号"
        ></el-table-column>
        <el-table-column
          prop="proUnit"
          label="单位"
        ></el-table-column>
        <el-table-column
          prop="quantity"
          label="数量"
        ></el-table-column>
        <el-table-column
          prop="purchasePrice"
          label="实付单价"
        >
          <template v-slot="{row}">{{row.purchasePrice|toFixed}}</template>
        </el-table-column>
        <el-table-column
          prop="totalMoney"
          label="实付总额"
        >
          <template v-slot="{row}">{{row.totalMoney|toFixed}}</template>
        </el-table-column>
        <el-table-column
          prop="taxRate"
          label="税率"
        >
          <template slot-scope="scope">
            <div>{{ (scope.row.taxRate *100).toFixed(2) }}%</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="taxAmount"
          label="税额"
        >
          <template v-slot="{row}">{{row.taxAmount|toFixed}}</template>
        </el-table-column>
      </el-table>
    </div>
    <!-------------- 工单日志 -------------->
    <operation-log-and-flow :flowLabel="flowLabel"></operation-log-and-flow>
  </div>
</template>
<script>
import { queryPurchaseContractInvociesListVo } from '@/api/purchase/purchasePlanList'
import { formatDate } from '@/util/tool'
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
export default {
  components: {
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {
      dataList: [
        '待审核',
        '审核中',
        '履行中',
        '已履行',
        '审核通过待签署',
        '已作废',
        '审核不通过',
        '审核驳回'
      ],
      params: {}, // 数据
      list: [],
      loadingTable: false,
      flowLabel: '收票流程',
      status: ['收票审核', '已收票', '已退票', '审核不通过', '退票中']
    }
  },
  mounted () {
    queryPurchaseContractInvociesListVo(this.$route.query.invoiceReceiveNumber)
      .then((res) => {
        if (res.data.code === 200) {
          this.params = res.data.obj
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    // 合同编号跳转
    pcbNumberClick (row) {
      if (row.contractState === 4) {
        this.$router.push({
          name: 'contractDetails',
          query: { type: '已履行', pcbId: row.pcbId }
        })
      } else if (row.contractState === 3) {
        this.$router.push({
          name: 'contractDetails',
          query: { type: '履行中', pcbId: row.pcbId }
        })
      } else {
        let typeData = ''
        typeData = this.dataList[row.contractState - 1]
        this.$router.push({
          name: 'createContract',
          query: { type: typeData, pcbId: row.pcbId }
        })
      }
    },
    // 产品跳转
    proNameClick (row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    // 供应商跳转
    suNameClick (row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}

function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
